import { createContext, useContext } from 'react';

import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { IDealsListViewConfig } from '~/src/dash/views/deal/dealsV2/DealsListView/config';

interface IDealsListContext {
  cfg: IDealsListViewConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
}

export const DealsListContext = createContext({} as IDealsListContext);
export const useDealsListStore = (): IDealsListContext => useContext(DealsListContext);
